import Service from '../abstract/service'
import Empresa from '../empresa'

export default class Financiamento extends Service {
  constructor() {
    super()
    this._financiamentoRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Tabelas`
    )
    this._dataSyncRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/DataSync`
    )
    this._serviceEmpresa = new Empresa()
  }

  async getByEmpresas(empresas) {
    try {
      this._loading.setLoading(true, 'Carregando dados')
      const response = await this._financiamentoRef
        .where('empresas', 'array-contains-any', empresas)
        .get()

      let financiamentos = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          financiamentos.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(financiamentos)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getByAtivo(ativo) {
    try {
      this._loading.setLoading(true, 'Carregando dados')
      const response = await this._financiamentoRef
        .where('ativo', '==', ativo)
        .get()

      let financiamentos = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          financiamentos.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(financiamentos)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async criaHistoricoAtualizacaoAtivo(financiamento, usuario) {
    try {
      this._loading.setLoading(true, 'Salvando dados')
      this._historicoRef = this._db.collection(
        `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Tabelas/${financiamento.id}/historicoAtualizacaoAtivo`
      )
      let acao = 'desativar'
      if (financiamento.ativo) {
        acao = 'ativar'
      }
      await this._historicoRef.doc().set({
        data: new Date(),
        usuario,
        acao
      })

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async desativaSincronizacaoAntiga() {
    try {
      const response = await this._dataSyncRef.where('ativo', '==', true)
        .where('descricao', '==', 'Tabelas')
        .get()
      if (!response.empty) {
        const [doc] = response.docs
        const sincAntiga = await this._dataSyncRef.doc(doc.id)
        await sincAntiga.update({ ativo: false })
      }
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async criaSincronizacao(fabricante) {
    try {
      const empresas = await this._serviceEmpresa.getByFabricante(fabricante)
      this._loading.setLoading(true, 'Gerando Sincronização')

      await this.desativaSincronizacaoAntiga()
      await this._dataSyncRef.doc().set({
        ativo: true,
        dataCriacao: new Date(),
        descricao: 'Tabelas',
        empresas: empresas.map(empresa => empresa.cnpj)
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async create(financiamento) {
    try {
      this._loading.setLoading(true, 'Salvando dados')
      let doc = await this._financiamentoRef.doc()
      await doc.set(financiamento)
      financiamento.id = doc.id

      return Promise.resolve(financiamento)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async update(financiamento) {
    try {
      this._loading.setLoading(true, 'Atualizando dados')
      const response = await this._financiamentoRef.doc(financiamento.id)
      delete financiamento.id
      response.update(financiamento)

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
